import { render } from "./lists.vue?vue&type=template&id=0dfad7ce&scoped=true&ts=true"
import script from "./lists.vue?vue&type=script&lang=ts"
export * from "./lists.vue?vue&type=script&lang=ts"

import "./lists.vue?vue&type=style&index=0&id=0dfad7ce&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfad7ce"]])

export default __exports__